import { useId, type ReactNode } from "react";
import { PixelText } from "./pixel";

/**
 * Fenêtre modale : l'écran de la borne se couvre de lignes de balayage, une fiche s'y dessine. Le bouton
 * principal prend le focus (`autoFocus`) pour que la touche Entrée y réponde.
 */
export function Dialog({ title, children, footer }: { title: string; children?: ReactNode; footer?: ReactNode }) {
  const id = useId();
  return (
    <div className="scanlines pointer-events-auto fixed inset-0 z-40 grid place-items-center p-3">
      <div role="dialog" aria-modal="true" aria-labelledby={id} className="wipe-in w-full max-w-[28rem]">
        <div className="bezel">
          <div className="max-h-[min(80vh,40rem)] overflow-y-auto overscroll-contain px-3 pb-3 pt-2">
            <h2 id={id} className="dotted pb-3 pt-1 text-ink">
              <PixelText text={title} />
            </h2>
            {children}
            {footer ? <div className="mt-6 flex flex-col gap-2">{footer}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
}
